import React, { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import TranslateIcon from '@mui/icons-material/Translate';
import useCookie from '../../_hook/useCookie';
import { COOKIE_KEY } from '../../constant/cookie';
import InputTranslationLanguageSelect from './_module/InputTranslationLanguageSelect';

interface IProps {
  values: {
    la: string;
    text: string;
  }[];
  onChange: (
    values: {
      la: string;
      text: string;
    }[]
  ) => void;
  label?: string;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  onBlur?: () => void;
}

export default function InputTranslationTextField(props: IProps) {
  const {
    disabled,
    values,
    onChange: propOnChange,
    label,
    required,
    fullWidth,
    error,
    helperText,
    onBlur,
  } = props;
  const { cookies } = useCookie([COOKIE_KEY.LANGUAGE]);
  const [language, setLanguage] = useState<any>(cookies[COOKIE_KEY.LANGUAGE]);

  function onChange(newValue: string) {
    let newValues = [...values];

    if (values && values.find((propValue) => propValue.la === language)) {
      newValues = newValues.map((item) => {
        if (item.la === language) {
          item.text = newValue;
        }
        return item;
      });
    } else {
      newValues.push({
        la: language,
        text: newValue,
      });
    }

    if (propOnChange) {
      propOnChange(newValues);
    }
  }

  let currentValue = values.find((item) => item.la === language);

  if (!currentValue) {
    currentValue = {
      la: language,
      text: '',
    };
  }

  return (
    <TextField
      label={label}
      disabled={disabled}
      required={required}
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TranslateIcon />
            <InputTranslationLanguageSelect
              language={language}
              onChange={setLanguage}
              type="input"
            />
          </InputAdornment>
        ),
      }}
      value={currentValue.text}
      error={error}
      helperText={helperText}
      onChange={(evt) => {
        onChange(evt.target.value);
      }}
      onBlur={onBlur}
    />
  );
}
